import React from 'react'
import styles from '../stylesheets/NavItem.module.scss'

// function NavItem({text, ...restProps}) {
function NavItem ( props) {

    return (
       <a
        href={ props.target }
        className={ props.appendClass ?  `${styles.navItem} ${styles.active}` : styles.navItem }
        >{ props.text }
        </a>
    )
}

export default NavItem
